import React from 'react';
import './scss/contract-add.scss';
import ProcessInfoContractProp from './properties/process-info-contract';
import Utils from '../common/utils';
import FormDialog from './form-dialog';
import ProcessUpdateContract from './process-contract-update';

function ProcessInfoContract({processContract, setStatusMessage}: ProcessInfoContractProp):
    React.ReactElement {
    const [updateModalShow, setUpdateModalShow] = React.useState(false);
    const handleEditClick = (event: any) => {
        event.preventDefault();
        setUpdateModalShow(true);
    };
    const handleFormSubmit = (event: any) => {
        event.preventDefault();
    };

    return (
        <div>
            <FormDialog
                show={updateModalShow}
                onHide={() => {
                    setUpdateModalShow(false);
                }}
                setStatusMessage={setStatusMessage}
                onSubmit={handleFormSubmit}
                formElement={(
                    <ProcessUpdateContract
                        hash={processContract.hash}
                        setStatusMessage={setStatusMessage}
                        handleClose={() => {
                            setUpdateModalShow(false);
                        }}
                    />
                )}
            />
            <div className="pb-2 pt-2 text-end">
                <a
                    className="text-decoration-underline"
                    href="#process-edit"
                    onClick={((e) => handleEditClick(e))}
                >
                    Edit Details
                </a>
            </div>
            <div className="row process-container mb-3" style={{backgroundColor: '#faebd7'}}>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Start Block</h6>
                    <p className="text-uppercase">
                        {processContract?.startBlock === '' ? '-' : processContract?.startBlock}
                    </p>
                </div>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">End Block</h6>
                    <p className="text-uppercase">
                        {processContract?.endBlock === '' ? '-' : processContract?.endBlock}
                    </p>
                </div>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Block Range</h6>
                    <p className="text-uppercase">
                        {processContract?.blockRange === '' ? '-' : processContract?.blockRange}
                    </p>
                </div>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Status</h6>
                    <div>
            <span className="text-uppercase pe-2">
              {processContract?.status === '' ? '-' : processContract?.status}
            </span>
                    </div>
                </div>
            </div>
            <div className="row process-container">
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Last Block Saved</h6>
                    <p className="text-uppercase">
                        {processContract?.lastBlockSaved === '' ? '-' : processContract?.lastBlockSaved}
                    </p>
                </div>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Last Block Processed</h6>
                    <p className="text-uppercase">
                        {processContract?.lastBlockProcessed === '' ? '-' : processContract?.lastBlockProcessed}
                    </p>
                </div>
                <div className="col-sm-3">
                    <h6 className="text-uppercase">Last Update Time</h6>
                    <p className="text-uppercase">
                        {processContract?.lastUpdateTime === '' ? '-' : Utils.formatDateString(processContract?.lastUpdateTime)}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ProcessInfoContract;
